(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/fractiongames/dialogs/payment-confirm.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/fractiongames/dialogs/payment-confirm.js');
'use strict';

const _svs$numbergames$prod = svs.numbergames.productMapping,
  getProductName = _svs$numbergames$prod.getProductName,
  isDaySpecificId = _svs$numbergames$prod.isDaySpecificId,
  getDay = _svs$numbergames$prod.getDay;
const isPayAfterDeposit = svs.tur.payment.utils.misc.isPayAfterDeposit;
class PaymentConfirm extends svs.tur.payment.dialogs.PaymentConfirm {
  constructor(_ref) {
    let productName = _ref.productName,
      productNumeric = _ref.productNumeric,
      price = _ref.price,
      accountBalance = _ref.accountBalance,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel;
    super({
      productName,
      productNumeric,
      price,
      accountBalance,
      isCancelable: false,
      onConfirm,
      onCancel
    });
  }
  getTitle() {
    return "".concat(isPayAfterDeposit() ? 'Din insättning är klar.<br>' : '', "Vill du k\xF6pa en andel f\xF6r ").concat(this.price, " kr<br /> p\xE5 ").concat(getProductName(this.productName)).concat(isDaySpecificId(this.productNumeric) ? " ".concat(getDay(this.productNumeric).toLowerCase()) : '', "?");
  }
  getMessage() {
    return [{
      type: svs.components.dialog.message.TEXT,
      text: 'Summan reserveras från ditt spelkonto och spelet lämnas in när sista andelen är såld.',
      align: svs.components.dialog.message.align.CENTER
    }, {
      type: svs.components.dialog.message.TEXT,
      text: this.getCancelableInfo(),
      align: svs.components.dialog.message.align.CENTER
    }, {
      type: svs.components.dialog.message.TEXT,
      text: "Ditt saldo: ".concat(svs.utils.format.Currency(this.accountBalance), " kr"),
      align: svs.components.dialog.message.align.CENTER
    }];
  }
}
svs.tur.payment.api.jupiter.fractiongames.dialogs.PaymentConfirm = PaymentConfirm;

 })(window);